var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import UserAvatar from '@web/components/UserAvatar';
import { drivePeopleActivityFields } from '@workalizer/shared/enums';
import React from 'react';
var activityMetricCellClass = '!text-left !px-4';
var activityMetricValueClass = 'pl-2 text-sm text-gray-900 tabular-nums';
var PEOPLE_ACTIVITY_FIELD_KEYS = [
    drivePeopleActivityFields.views,
    drivePeopleActivityFields.edits,
    drivePeopleActivityFields.downloads,
    drivePeopleActivityFields.prints,
    drivePeopleActivityFields.commentsPosted,
    drivePeopleActivityFields.commentsResolved,
    drivePeopleActivityFields.suggestionsPosted,
    drivePeopleActivityFields.suggestionsResolved,
    drivePeopleActivityFields.sharedInternally,
    drivePeopleActivityFields.sharedExternally,
    drivePeopleActivityFields.sharedPublicly
];
export var getPeopleActivityFields = function (t) {
    return PEOPLE_ACTIVITY_FIELD_KEYS.map(function (key) { return ({
        key: key,
        title: t("driveItemDetails.peopleActivityTable.".concat(key))
    }); });
};
export var processPeopleActivityData = function (activityData, t, sortingOption) {
    if (!activityData)
        return [];
    var fields = getPeopleActivityFields(t);
    var users = __spreadArray([], activityData.users, true);
    if (sortingOption === null || sortingOption === void 0 ? void 0 : sortingOption.show) {
        users.sort(function (a, b) {
            var field = sortingOption.orderByField;
            var direction = sortingOption.direction === 'asc' ? 1 : -1;
            if (field === 'user') {
                return direction * (a.name || a.email).localeCompare(b.name || b.email);
            }
            return (direction *
                (a[field] -
                    b[field]));
        });
    }
    return __spreadArray(__spreadArray([], users.map(function (user) { return __spreadArray([
        {
            id: "user-".concat(user.userId),
            className: activityMetricCellClass,
            render: function () { return (_jsxs("div", __assign({ className: "flex items-center gap-2 min-w-[180px]" }, { children: [_jsx(UserAvatar, { user: user, size: "small" }), _jsxs("div", __assign({ className: "min-w-0" }, { children: [_jsx("div", __assign({ className: "text-sm font-medium text-gray-900 truncate" }, { children: user.name || user.email })), user.orgUnitTitle && (_jsx("div", __assign({ className: "text-xs text-gray-500 truncate" }, { children: user.orgUnitTitle })))] }))] }))); }
        }
    ], fields.map(function (_a) {
        var key = _a.key;
        return ({
            id: "".concat(key, "-").concat(user.userId),
            className: activityMetricCellClass,
            render: function () { return (_jsx("span", __assign({ className: activityMetricValueClass }, { children: user[key] }))); }
        });
    }), true); }), true), [
        __spreadArray([
            {
                id: 'total-user',
                className: activityMetricCellClass,
                render: function () { return (_jsx("div", __assign({ className: "flex items-center" }, { children: _jsx("span", __assign({ className: "text-sm font-medium text-gray-900" }, { children: t('driveItemDetails.peopleActivityTable.total') })) }))); }
            }
        ], fields.map(function (_a) {
            var key = _a.key;
            return ({
                id: "total-".concat(key),
                className: activityMetricCellClass,
                render: function () { return (_jsx("span", __assign({ className: activityMetricValueClass }, { children: activityData.totals[key] }))); }
            });
        }), true)
    ], false);
};
